import { useState } from 'react';
import { makeAutoObservable } from 'mobx';
import { v4 as UUID } from 'uuid';

export type ToastType = 'info' | 'success' | 'error';
export type ToastMessage = {
  id: string;
  message: string;
  type: ToastType;
  closing: boolean;
};

class ToastState {
  toasts: ToastMessage[] = [];

  constructor() {
    makeAutoObservable(this);
  }

  showToast(message: string, type: ToastType = 'info') {
    const id = UUID();
    this.toasts.push({ id, message, type, closing: false });
    setTimeout(() => {
      this.closeToast(id);
    }, 5000);
  }

  closeToast(id: string) {
    this.toasts = this.toasts.map((t) => (t.id === id ? { ...t, closing: true } : t));
    setTimeout(() => {
      this.hideToast(id);
    }, 300);
  }

  hideToast(id: string) {
    this.toasts = this.toasts.filter((t) => t.id !== id);
  }
}

export const toastState = new ToastState();

export function useToast() {
  return toastState;
}
